// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Chip,
//   Paper,
//   IconButton,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   DialogContentText,
//   Select,
//   MenuItem,
//   Container,
//   FormControl,
//   Divider,
//   Snackbar,
//   Alert,
//   Grid,
//   Breadcrumbs,
// } from "@mui/material";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import {
//   ContentCopy,
//   Download,
//   Delete,
//   CloudUpload,
//   AutoFixHigh,
//   Tune,
//   Circle,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   checkCompression,
//   checkExpansion,
//   checkPhrasing,
// } from "../../services/englishCheckers";
// import Loader from "../../utils/loader";
// import { connect } from "react-redux";
// import adminServices from "../../services/adminServices";
// import { useSelector } from "react-redux";
// import { addUserLogs } from "../../services/userLogServices";
// import { useCheckFeatureAccess } from "../CheckFeature";
// import SubscriptionRequired from "../SubscriptionRequired";
// import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
// import { checkAIRequestLimit } from "../aiRequestLimit";
// import { useHistory } from "react-router-dom";
// import jwtDecode from "jwt-decode";

// function NewParaphrase({ features, trial = false }) {
//   const [inputText, setInputText] = useState("");
//   const [outputText, setOutputText] = useState("");
//   const userDetails = useSelector((state) => state.user);

//   // const userID = userDetails?.currentUser?._id || "";
//   const token = sessionStorage.getItem("token");

//   const getIdentityFromToken = () => {
//     const token =
//       sessionStorage.getItem("token") || localStorage.getItem("token");

//     if (!token) return null;

//     try {
//       const decoded = jwtDecode(token);

//       if (decoded.role === "guest") {
//         return { machineId: decoded.machineId };
//       } else {
//         return { userId: decoded._id };
//       }
//     } catch (err) {
//       console.error("Invalid token");
//       return null;
//     }
//   };

//   const identity = getIdentityFromToken();
//   const [characters, setCharacters] = useState({ max: 1500, now: 0 });
//   const [loading, setLoading] = useState(false);
//   const [isParaphrase, setIsParaphrase] = useState(false);
//   const [isCustomOpen, setIsCustomOpen] = useState(false);
//   const [customText, setCustomText] = useState("Custom");
//   const [customTextValue, setCustomTextValue] = useState("");
//   const [selectedTone, setSelectedTone] = useState("standard");
//   const [selectDropdownTone, setSelectDropdownTone] = useState("select");
//   const [windowWidth, setWindowWidth] = useState(0);
//   const [isClient, setIsClient] = useState(false);
//   const history = useHistory();
  
//   // State for word limit warning dialog
//   const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
//   const [wordLimitExceeded, setWordLimitExceeded] = useState(false);
  
//   const accessToUpload = useCheckFeatureAccess("paraphraser", "upload");
//   const accessToParaphrase = useCheckFeatureAccess("paraphraser", "paraphrase");
//   const accessToDelete = useCheckFeatureAccess("paraphraser", "delete");
//   const accessToParaphraserScreen =
//     useCheckSubscriptionPlanAccess("Paraphraser");
//   const accessTocustom = useCheckSubscriptionPlanAccess("custom");
//   const [subReqOpen, setSubReqOpen] = useState(false);
//   const [notification, setNotification] = useState({
//     open: false,
//     message: "",
//   });

//   const accessToTone = useCheckSubscriptionPlanAccess("tone");
//   const accessToMoreOptions = useCheckSubscriptionPlanAccess("moreOptions");

//   const fileInputRef = useRef(null);

//   const buttons = [
//     { id: "standard", label: "Standard", icon: "📝" },
//     { id: "formal", label: "Formal", icon: "🎩" },
//     { id: "casual", label: "Casual", icon: "😊" },
//     { id: "positive", label: "Positive", icon: "✨" },
//     { id: "confident", label: "Confident", icon: "💪" },
//     { id: "friendly", label: "Friendly", icon: "🤝" },
//     { id: "simple", label: "Simple", icon: "🔹" },
//   ];

//   const customSuggestions = [
//     { label: "Like a Story", icon: "📖" },
//     { label: "Like a Poem", icon: "✍️" },
//     { label: "Like a CEO", icon: "💼" },
//     { label: "Like a Doctor", icon: "🩺" },
//     { label: "Like a News", icon: "📰" },
//     { label: "Like a Sales Executive", icon: "📊" },
//     { label: "Like a Letter", icon: "✉️" },
//   ];

//   //full screen layout
//   useEffect(() => {
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";
//     return () => { };
//   }, []);

//   useEffect(() => {
//     setIsClient(true);
//     setWindowWidth(window.innerWidth);

//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (
//       !inputText.trim() &&
//       (selectDropdownTone === "shorten" || selectDropdownTone === "expand")
//     ) {
//       setSelectDropdownTone("select");
//     }
//   }, [inputText, selectDropdownTone]);

//   useEffect(() => {
//     if (accessToParaphraserScreen === false) {
//       setSubReqOpen(true);
//     }
//   }, [accessToParaphraserScreen]);

//   useEffect(() => {
//     if (isClient) {
//       getParaphraseLimit();
//     }
//   }, [isClient]);

//   const getParaphraseLimit = async () => {
//     try {
//       let data = await adminServices.getParaphraseLimit();
//       setCharacters({ max: data.paraphrase_limit, now: 0 });
//     } catch (error) {
//       console.error("Error getting paraphrase limit:", error);
//       toast.error("Failed to load paraphrase limits");
//     }
//   };

//   const handleInputChange = (event) => {
//     const text = event.target.value;
//     const length = text.length;

//     if (length > characters.max) {
//       toast.warn(
//         `Character limit exceeded. Maximum ${characters.max} characters allowed.`,
//       );
//       return;
//     }

//     setInputText(text);
//     setCharacters({ ...characters, now: length });

//     if (isParaphrase) {
//       setIsParaphrase(false);
//       setOutputText("");
//     }
//   };

//   const GrammerCheckForParaphrase = async (type) => {
//     setLoading(true);

//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         isCoAuthor: false,
//         ...identity,
//       };

//       if (type && type !== "defaultPrompt") {
//         if (
//           [
//             "Like a story",
//             "Like a poem",
//             "Like a letter",
//             "Like a sales executive",
//             "Like a news",
//             "Like a Doctor",
//             "Like a CEO",
//           ].includes(type)
//         ) {
//           data.tone = "custom";
//           data.customTone = type;
//         } else {
//           data.tone = type;
//         }
//       }

//       const paraphraseResponse = await checkPhrasing(data);

//       if (paraphraseResponse && paraphraseResponse.data) {
//         let outputText = "";

//         if (Array.isArray(paraphraseResponse.data.output)) {
//           outputText = paraphraseResponse.data.output.join("\n");
//         } else if (typeof paraphraseResponse.data.output === "string") {
//           outputText = paraphraseResponse.data.output;
//         } else if (paraphraseResponse.data.paraphrasedText) {
//           outputText = paraphraseResponse.data.paraphrasedText;
//         } else if (paraphraseResponse.data.result) {
//           outputText = paraphraseResponse.data.result;
//         } else {
//           outputText = JSON.stringify(paraphraseResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         try {
//           const logData = {
//             // userId: sessionStorage.getItem("userId"),
//             // organizationId: sessionStorage.getItem("organizationId"),
//             ...identity,
//             actionType: "paraphrase",
//           };
//           await addUserLogs(logData);
//         } catch (logError) {
//           console.error("Error logging user action:", logError);
//         }

//         toast.success("Text paraphrased successfully!");
//       } else {
//         toast.error("No valid response received from the server");
//       }
//     } catch (error) {
//       console.error("Error in GrammerCheckForParaphrase:", error);
//       toast.error("Failed to paraphrase text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkWordsCompression = async () => {
//     setLoading(true);
//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         ...identity,
//       };

//       const wordCompressionResponse = await checkCompression(data);

//       if (wordCompressionResponse && wordCompressionResponse.data) {
//         let outputText = "";

//         if (Array.isArray(wordCompressionResponse.data.output)) {
//           outputText = wordCompressionResponse.data.output.join("\n");
//         } else if (typeof wordCompressionResponse.data.output === "string") {
//           outputText = wordCompressionResponse.data.output;
//         } else {
//           outputText = JSON.stringify(wordCompressionResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         toast.success("Content has been shortened.");
//       } else {
//         toast.error("No response received for compression");
//       }
//     } catch (error) {
//       console.error("Error in checkWordsCompression:", error);
//       toast.error("Failed to compress text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkWordsExpansion = async () => {
//     setLoading(true);
//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         ...identity,
//       };

//       const wordExpansionResponse = await checkExpansion(data);

//       if (wordExpansionResponse && wordExpansionResponse.data) {
//         let outputText = "";

//         if (Array.isArray(wordExpansionResponse.data.output)) {
//           outputText = wordExpansionResponse.data.output.join("\n");
//         } else if (typeof wordExpansionResponse.data.output === "string") {
//           outputText = wordExpansionResponse.data.output;
//         } else {
//           outputText = JSON.stringify(wordExpansionResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         toast.success("The content has been enriched with more details.");
//       } else {
//         toast.error("No response received for expansion");
//       }
//     } catch (error) {
//       console.error("Error in checkWordsExpansion:", error);
//       toast.error("Failed to expand text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const [isFeatureInside, setIsFeatureInside] = useState(false);

//   // Updated handleFutureButton with word limit check
//   const handleFutureButton = async (type) => {
//     // Check word limit first
//     const wordCount = countWords(inputText);
    
//     if (wordCount > 1500) {
//       setWordLimitDialogOpen(true);
//       setWordLimitExceeded(true);
//       return;
//     }

//     if (accessToMoreOptions == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }
//     try {
//       if (accessTocustom == false) {
//         setSubReqOpen(true);
//         setIsFeatureInside(true);
//         return;
//       }
//       // const checkailimit = await checkAIRequestLimit(identity);
//       // if (checkailimit === false) {
//       //   toast.warn("AI request limit reached.");
//       //   return;
//       // }

//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         return;
//       }

//       if (type === "shorten") {
//         await checkWordsCompression();
//         setCustomText("Custom");
//       } else if (type === "expand") {
//         await checkWordsExpansion();
//         setCustomText("Custom");
//       } else if (type === "custom") {
//         setIsCustomOpen(true);
//       } else {
//         await GrammerCheckForParaphrase(type);
//         setCustomText("Custom");
//       }
//     } catch (error) {
//       console.error("Error in handleFutureButton:", error);
//       toast.error("An error occurred. Please try again.");
//     }
//   };

//   // Updated onPetAssistant with word limit check
//   const onPetAssistant = async () => {
//     // Check word limit first
//     const wordCount = countWords(inputText);
    
//     if (wordCount > 1500) {
//       setWordLimitDialogOpen(true);
//       setWordLimitExceeded(true);
//       return;
//     }

//     try {
//       // const checkailimit = await checkAIRequestLimit(identity);
//       // if (checkailimit === false) {
//       //   toast.warn("AI request limit reached.");
//       //   return;
//       // }

//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         return;
//       }

//       await GrammerCheckForParaphrase("standard");
//     } catch (error) {
//       console.error("Error in onPetAssistant:", error);
//       toast.error("An error occurred while processing your request.");
//     }
//   };

//   // Handle word limit dialog close
//   const handleWordLimitDialogClose = () => {
//     setWordLimitDialogOpen(false);
//     setWordLimitExceeded(false);
//   };

//   const handleDelete1 = () => {
//     setInputText("");
//     setOutputText("");
//     setIsParaphrase(false);
//     setCharacters({ ...characters, now: 0 });
//   };

//   const handleDelete = () => {
//     setOutputText("");
//     setIsParaphrase(false);
//   };

//   const handleCopy = () => {
//     if (!outputText.trim()) {
//       toast.warn("No text to copy");
//       return;
//     }

//     navigator.clipboard.writeText(outputText).then(
//       () => {
//         toast.success("Text copied to clipboard!");
//       },
//       (err) => {
//         console.error("Could not copy text: ", err);
//         toast.error("Failed to copy text");
//       },
//     );
//   };

//   const handleDownload = () => {
//     if (!outputText.trim()) {
//       toast.warn("No text to download");
//       return;
//     }

//     const blob = new Blob([outputText], { type: "text/plain" });
//     const anchor = document.createElement("a");
//     anchor.href = URL.createObjectURL(blob);
//     anchor.download = "paraphrased_text.txt";
//     anchor.click();
//     URL.revokeObjectURL(anchor.href);
//     toast.success("File downloaded successfully!");
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (!file.name.endsWith(".txt")) {
//       toast.warn("Only .txt files are supported");
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const text = event.target.result;
//       const wordCount = countWords(text);

//       if (wordCount > 1500) {
//         toast.warn("File content exceeds 1500 word limit");
//         return;
//       }

//       setInputText(text);
//       toast.success("File uploaded successfully!");
//     };

//     reader.onerror = () => {
//       toast.error("Failed to read file");
//     };

//     reader.readAsText(file);
//   };

//   const handleCustomSelection = (type) => {
//     if (!inputText.trim()) {
//       toast.warning("Please input some text!");
//       return;
//     }

//     GrammerCheckForParaphrase(type);
//     setCustomText(type);
//     setIsCustomOpen(false);
//     setCustomTextValue("");
//   };

//   const handleCustomClick = () => {
//     if (!customTextValue.trim()) {
//       toast.warning("Please enter a custom tone");
//       return;
//     }

//     handleCustomSelection(customTextValue);
//   };

//   const handleSuggestionChange = (e) => {
//     setCustomTextValue(e.target.value);
//   };

//   const handleClose = () => {
//     setIsCustomOpen(false);
//     setCustomTextValue("");
//   };
//   const handleBreadcrumbClick = (event, path) => {
//     event.preventDefault();
//      window.location.href = "/docTags";
//     // history.push(path);
//   };
//   const handleToneClick = (toneId) => {
//     if (accessToTone == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }
//     setSelectedTone(toneId);
//     handleFutureButton(toneId);
//   };

//   const countWords = (text) => {
//     return text.trim().length > 0 ? text.trim().split(/\s+/).length : 0;
//   };

//   const inputWordCount = countWords(inputText);
//   const outputWordCount = countWords(outputText);

//   const renderSelect = () => {
//     if (!isClient) return null;

//     return (
//       <FormControl size="small" sx={{ minWidth: 100 }}>
//         <Select
//           value={selectDropdownTone}
//           onChange={(e) => {
//             const selectedValue = e.target.value;
//             if (selectedValue !== "select") {
//               handleFutureButton(selectedValue);
//               setSelectedTone(selectedValue);
//               setSelectDropdownTone(selectedValue);
//             }
//           }}
//           displayEmpty
//           sx={{
//             borderRadius: 2,
//             height: 36,
//             "& .MuiSelect-select": {
//               display: "flex",
//               alignItems: "center",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             },
//           }}
//           MenuProps={{
//             PaperProps: {
//               sx: {
//                 maxHeight: 300,
//                 "& .MuiMenuItem-root": {
//                   minHeight: 36,
//                   display: "flex",
//                   alignItems: "center",
//                 },
//               },
//             },
//           }}
//         >
//           <MenuItem value="select">More Options</MenuItem>
//           <MenuItem
//             disabled={!accessToParaphrase || !inputText.trim()}
//             value="shorten"
//           >
//             🔽 Shorten
//           </MenuItem>
//           <MenuItem
//             disabled={!accessToParaphrase || !inputText.trim()}
//             value="expand"
//           >
//             🔼 Expand
//           </MenuItem>
//         </Select>
//       </FormControl>
//     );
//   };

//   if (!isClient) {
//     return (
//       <Box
//         sx={{
//           height: "95vh",
//           display: "flex",
//           flexDirection: "column",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #e7ecf4ff 100%)",
//           overflow: "hidden",
//         }}
//       >
//         <Loader loading={true} />
//       </Box>
//     );
//   }

//   return (
//     <>
//       <SubscriptionRequired
//         open={subReqOpen}
//         setOpen={setSubReqOpen}
//         isFeatureInside={isFeatureInside}
//         setIsFeatureInside={setIsFeatureInside}
//         path={"paraphrase"}
//       />
      
//       {/* Word Limit Warning Dialog - with high z-index */}
//       <Dialog
//         open={wordLimitDialogOpen}
//         onClose={handleWordLimitDialogClose}
//         aria-labelledby="word-limit-dialog-title"
//         aria-describedby="word-limit-dialog-description"
//         sx={{
//           zIndex: 100000,
//           '& .MuiDialog-container': {
//             zIndex: 100000,
//           },
//           '& .MuiDialog-paper': {
//             zIndex: 100001,
//             borderRadius: 3,
//             padding: 2,
//             minWidth: 400,
//           }
//         }}
//       >
//         <DialogTitle 
//           id="word-limit-dialog-title"
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//             color: '#ef4444',
//             fontWeight: 600
//           }}
//         >
//           <WarningIcon sx={{ fontSize: 28 }} />
//           Word Limit Exceeded
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText 
//             id="word-limit-dialog-description"
//             sx={{
//               color: '#4b5563',
//               fontSize: '1rem'
//             }}
//           >
//             You have entered <strong>{inputWordCount}</strong> words, which exceeds the maximum limit of <strong>1500 words</strong>.
//           </DialogContentText>
//           <Box sx={{ mt: 2, p: 2, bgcolor: '#f3f4f6', borderRadius: 2 }}>
//             <Typography variant="body2" sx={{ color: '#1f2937' }}>
//               Please reduce your text to 1500 words or less to continue with paraphrasing.
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button 
//             onClick={handleWordLimitDialogClose}
//             variant="contained"
//             sx={{
//               bgcolor: '#ef4444',
//               '&:hover': {
//                 bgcolor: '#dc2626'
//               },
//               borderRadius: 2,
//               px: 4
//             }}
//           >
//             OK, Got it
//           </Button>
//         </DialogActions>
//       </Dialog>
      
//       {/* ToastContainer with high z-index */}
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         style={{ zIndex: 99999 }}
//         containerStyle={{ zIndex: 99999 }}
//       />
      
//       {/* CSS for high z-index elements */}
//       <style>
//         {`
//           .swal2-container {
//             z-index: 100000 !important;
//           }
//           .swal2-popup {
//             z-index: 100001 !important;
//           }
//         `}
//       </style>
      
//       <Box
//         sx={{
//           position: "fixed",
//           inset: 0,
//           zIndex: 9998,
//           overflowY: "auto",
//           overflowX: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
//         }}
//       >
//         <Loader loading={loading} />
//         <Container
//           maxWidth="xl"
//           disableGutters
//           sx={{
//             flex: 1,
//             display: "flex",
//             flexDirection: "column",
//             minHeight: "100%",
//             px: 1,
//             py: 1,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               position: "relative",
//               width: "100%",
//             }}
//           >
//             {/* LEFT SIDE - Breadcrumb */}
//             <Box sx={{ display: "flex", alignItems: "center", mt: 1, p: 1 }}>
//               <Paper
//                 elevation={1}
//                 sx={{
//                   p: 1.5,
//                   bgcolor: "white",
//                   borderRadius: 3,
//                   border: "1px solid",
//                   borderColor: "divider",
//                   transition: "all 0.3s ease",
//                   "&:hover": {
//                     boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
//                   },
//                 }}
//               >
//                 <Breadcrumbs
//                   separator={
//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />
//                   }
//                   aria-label="breadcrumb"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     flexWrap: "nowrap",
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

//                     <Link
//                       to="/docTags"
//                       onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
//                       style={{
//                         textDecoration: "none",
//                         color: "#667eea",
//                         fontWeight: 500,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       MultiTool AI
//                     </Link>

//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />

//                     <Typography
//                       sx={{
//                         color: "#1a1a1a",
//                         fontWeight: 600,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         backgroundColor: "rgba(102, 126, 234, 0.08)",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       AI Paraphraser
//                     </Typography>
//                   </Box>
//                 </Breadcrumbs>
//               </Paper>
//             </Box>

//             {/* CENTER CONTENT */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 textAlign: "center",
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <AutoFixHigh sx={{ fontSize: 36, color: "primary.main" }} />
//                 <Box>
//                   <Typography
//                     sx={{
//                       fontSize: 22,
//                       fontWeight: 700,
//                       color: "primary.main",
//                     }}
//                   >
//                     AI Paraphraser
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{ color: "text.secondary", fontStyle: "italic" }}
//                   >
//                     Transform your text with intelligent rephrasing powered by
//                     AI
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           <Box sx={{ flexShrink: 0, p: 1 }}>
//             <Card
//               elevation={0}
//               sx={{
//                 borderRadius: 3,
//                 background: "rgba(255, 255, 255, 0.95)",
//                 backdropFilter: "blur(10px)",
//                 border: "1px solid rgba(255, 255, 255, 0.3)",
//               }}
//             >
//               <CardContent sx={{ pb: 2, "&:last-child": { pb: 2 } }}>
//                 <Box sx={{ mb: 1 }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight={600}
//                   >
//                     Output Format
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                   >
//                     Select how you want to display the paraphrased content
//                   </Typography>
//                 </Box>

//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     gap: 1.5,
//                     alignItems: "center",
//                     minHeight: 40,
//                   }}
//                 >
//                   {buttons.map((button) => (
//                     <Chip
//                       key={button.id}
//                       icon={
//                         <span style={{ fontSize: "16px" }}>{button.icon}</span>
//                       }
//                       label={button.label}
//                       disabled={!inputText || !accessToParaphrase}
//                       onClick={() => handleToneClick(button.id)}
//                       color={selectedTone === button.id ? "primary" : "default"}
//                       variant={selectedTone === button.id ? "filled" : "outlined"}
//                       sx={{
//                         height: "36px",
//                         fontSize: "0.85rem",
//                         fontWeight: 600,
//                         transition: "all 0.3s",
//                         cursor: "pointer",
//                         "&:hover": {
//                           transform: "scale(1.05)",
//                           boxShadow: 2,
//                         },
//                       }}
//                     />
//                   ))}

//                   <Box
//                     sx={{
//                       ml: "auto",
//                       display: "flex",
//                       gap: 1,
//                       flexWrap: "wrap",
//                       alignItems: "center",
//                     }}
//                   >
//                     {renderSelect()}

//                     <Button
//                       variant="contained"
//                       onClick={() => handleFutureButton("custom")}
//                       disabled={!accessToParaphrase || !inputText.trim()}
//                       startIcon={<Tune />}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         height: 36,
//                         minWidth: 100,
//                         background: inputWordCount > 1500 
//                           ? "#ef4444" 
//                           : "linear-gradient(45deg, #667eea, #764ba2)",
//                         '&:hover': {
//                           background: inputWordCount > 1500 
//                             ? "#dc2626" 
//                             : "linear-gradient(45deg, #764ba2, #667eea)",
//                         }
//                       }}
//                     >
//                       {customText}
//                     </Button>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Box sx={{ flexGrow: 1, px: 1, pb: 3, minHeight: 0 }}>
//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
//                 gap: 3,
//                 minHeight: "500px",
//               }}
//             >
//               <Card
//                 elevation={4}
//                 sx={{
//                   height: "100%",
//                   borderRadius: 3,
//                   background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     bgcolor: "primary.main",
//                     color: "white",
//                     p: 2,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 2,
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     sx={{ fontWeight: 600, flexGrow: 1 }}
//                   >
//                     📝 Input Text
//                   </Typography>
//                   <Chip
//                     label={`${inputWordCount} Words`}
//                     size="small"
//                     sx={{
//                       bgcolor: inputWordCount > 1500 ? "#ef4444" : "rgba(255,255,255,0.2)",
//                       color: "white",
//                       fontWeight: 600,
//                     }}
//                   />
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     minHeight: "400px",
//                     maxHeight: "400px",
//                     overflow: "scroll",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       flex: 1,
//                       p: 2,
//                       overflow: "auto",
//                       height: "350px",
//                       "&::-webkit-scrollbar": {
//                         width: "8px",
//                       },
//                       "&::-webkit-scrollbar-track": {
//                         background: "#f5f5f5",
//                         borderRadius: "4px",
//                       },
//                       "&::-webkit-scrollbar-thumb": {
//                         background: "#c1c1c1",
//                         borderRadius: "4px",
//                         "&:hover": {
//                           background: "#a8a8a8",
//                         },
//                       },
//                     }}
//                   >
//                     <TextField
//                       multiline
//                       fullWidth
//                       value={inputText}
//                       onChange={handleInputChange}
//                       placeholder="✨ Start typing or paste your text here to paraphrase..."
//                       variant="outlined"
//                       InputProps={{
//                         sx: {
//                           fontSize: "15px",
//                           lineHeight: 1.6,
//                           minHeight: "320px",
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&:hover .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                         },
//                       }}
//                       sx={{
//                         "& .MuiInputBase-root": {
//                           minHeight: "320px",
//                           alignItems: "flex-start",
//                         },
//                         "& textarea": {
//                           overflow: "auto !important",
//                           minHeight: "300px !important",
//                           resize: "none",
//                         },
//                       }}
//                     />
//                   </Box>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: "black.50",
//                     borderTop: "1px solid",
//                     borderColor: "divider",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <Circle
//                       sx={{
//                         fontSize: 10,
//                         color: inputWordCount > 1500 ? "error.main" : "success.main",
//                       }}
//                     />
//                     <Typography
//                       variant="caption"
//                       sx={{ fontWeight: 600, color: "text.secondary" }}
//                     >
//                       {inputWordCount} / 1500 Words
//                     </Typography>
//                   </Box>

//                   <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                     <Button
//                       component="label"
//                       variant="outlined"
//                       size="small"
//                       disabled={!accessToUpload}
//                       startIcon={<CloudUpload />}
//                       sx={{ borderRadius: 2, textTransform: "none" }}
//                     >
//                       Upload
//                       <input
//                         ref={fileInputRef}
//                         type="file"
//                         accept=".txt"
//                         hidden
//                         onChange={handleFileUpload}
//                       />
//                     </Button>

//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={onPetAssistant}
//                       disabled={!inputText || !accessToParaphrase}
//                       startIcon={<AutoFixHigh />}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         background: inputWordCount > 1500 
//                           ? "#ef4444" 
//                           : "linear-gradient(45deg, #667eea, #764ba2)",
//                         '&:hover': {
//                           background: inputWordCount > 1500 
//                             ? "#dc2626" 
//                             : "linear-gradient(45deg, #764ba2, #667eea)",
//                         }
//                       }}
//                     >
//                       {!isParaphrase ? "Paraphrase" : "Re-Phrase"}
//                     </Button>

//                     <IconButton
//                       size="small"
//                       onClick={handleDelete1}
//                       disabled={!accessToDelete}
//                       sx={{
//                         color: accessToDelete ? "error.main" : "black.500",
//                       }}
//                     >
//                       <Delete />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               </Card>

//               <Card
//                 elevation={4}
//                 sx={{
//                   height: "100%",
//                   borderRadius: 3,
//                   background: "linear-gradient(145deg, #ffffff 0%, #e8f5e9 100%)",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     bgcolor: "success.main",
//                     color: "white",
//                     p: 2,
//                     borderRadius: "12px 12px 0 0",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                     ✨ Paraphrased Result
//                   </Typography>
//                   <Chip
//                     label={`${outputWordCount} Words`}
//                     size="small"
//                     sx={{
//                       bgcolor: "rgba(255,255,255,0.2)",
//                       color: "white",
//                       fontWeight: 600,
//                     }}
//                   />
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     minHeight: "400px",
//                     maxHeight: "400px",
//                     overflow: "scroll",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       flex: 1,
//                       p: 2,
//                       overflow: "auto",
//                       maxHeight: "100%",
//                       "&::-webkit-scrollbar": {
//                         width: "8px",
//                       },
//                       "&::-webkit-scrollbar-track": {
//                         background: "#f5f5f5",
//                         borderRadius: "4px",
//                       },
//                       "&::-webkit-scrollbar-thumb": {
//                         background: "#c1c1c1",
//                         borderRadius: "4px",
//                         "&:hover": {
//                           background: "#a8a8a8",
//                         },
//                       },
//                     }}
//                   >
//                     <TextField
//                       multiline
//                       fullWidth
//                       value={outputText}
//                       placeholder="Your paraphrased text will appear here..."
//                       variant="outlined"
//                       InputProps={{
//                         readOnly: true,
//                         sx: {
//                           fontSize: "15px",
//                           lineHeight: 1.6,
//                           minHeight: "300px",
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&:hover .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                         },
//                       }}
//                       sx={{
//                         "& .MuiInputBase-root": {
//                           minHeight: "300px",
//                           alignItems: "flex-start",
//                         },
//                         "& textarea": {
//                           overflow: "auto !important",
//                           minHeight: "300px !important",
//                           resize: "none",
//                         },
//                       }}
//                     />
//                   </Box>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: "black.50",
//                     borderTop: "1px solid",
//                     borderColor: "divider",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <Circle sx={{ fontSize: 10, color: "success.main" }} />
//                     <Typography
//                       variant="caption"
//                       sx={{ fontWeight: 600, color: "text.secondary" }}
//                     >
//                       {outputWordCount} Words Generated
//                     </Typography>
//                   </Box>

//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <IconButton
//                       size="small"
//                       onClick={handleDownload}
//                       disabled={!outputWordCount}
//                       sx={{
//                         color: outputWordCount ? "success.main" : "black.500",
//                       }}
//                     >
//                       <Download />
//                     </IconButton>

//                     <IconButton
//                       size="small"
//                       onClick={handleCopy}
//                       disabled={!outputWordCount}
//                       sx={{
//                         color: outputWordCount ? "info.main" : "black.500",
//                       }}
//                     >
//                       <ContentCopy />
//                     </IconButton>

//                     <IconButton
//                       size="small"
//                       onClick={handleDelete}
//                       disabled={!accessToDelete || !outputWordCount}
//                       sx={{
//                         color:
//                           accessToDelete && outputWordCount
//                             ? "error.main"
//                             : "black.500",
//                       }}
//                     >
//                       <Delete />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>
//           </Box>
//         </Container>
//       </Box>
//     </>
//   );
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
//   features: state.features.features,
// });

// export default connect(mapStateToProps)(NewParaphrase);

// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Chip,
//   Paper,
//   IconButton,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   DialogContentText,
//   Select,
//   MenuItem,
//   Container,
//   FormControl,
//   Divider,
//   Snackbar,
//   Alert,
//   Grid,
//   Breadcrumbs,
// } from "@mui/material";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import {
//   ContentCopy,
//   Download,
//   Delete,
//   CloudUpload,
//   AutoFixHigh,
//   Tune,
//   Circle,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   checkCompression,
//   checkExpansion,
//   checkPhrasing,
// } from "../../services/englishCheckers";
// import Loader from "../../utils/loader";
// import { connect } from "react-redux";
// import adminServices from "../../services/adminServices";
// import { useSelector } from "react-redux";
// import { addUserLogs } from "../../services/userLogServices";
// import { useCheckFeatureAccess } from "../CheckFeature";
// import SubscriptionRequired from "../SubscriptionRequired";
// import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
// import { checkAIRequestLimit } from "../aiRequestLimit";
// import { useHistory } from "react-router-dom";
// import jwtDecode from "jwt-decode";

// function NewParaphrase({ features, trial = false }) {
//   const [inputText, setInputText] = useState("");
//   const [outputText, setOutputText] = useState("");
//   const userDetails = useSelector((state) => state.user);

//   // const userID = userDetails?.currentUser?._id || "";
//   const token = sessionStorage.getItem("token");

//   const getIdentityFromToken = () => {
//     const token =
//       sessionStorage.getItem("token") || localStorage.getItem("token");

//     if (!token) return null;

//     try {
//       const decoded = jwtDecode(token);

//       if (decoded.role === "guest") {
//         return { machineId: decoded.machineId };
//       } else {
//         return { userId: decoded._id };
//       }
//     } catch (err) {
//       console.error("Invalid token");
//       return null;
//     }
//   };

//   const identity = getIdentityFromToken();
//   const [characters, setCharacters] = useState({ max: 1500, now: 0 });
//   const [loading, setLoading] = useState(false);
//   const [isParaphrase, setIsParaphrase] = useState(false);
//   const [isCustomOpen, setIsCustomOpen] = useState(false);
//   const [customText, setCustomText] = useState("Custom");
//   const [customTextValue, setCustomTextValue] = useState("");
//   const [selectedTone, setSelectedTone] = useState("standard");
//   const [selectDropdownTone, setSelectDropdownTone] = useState("select");
//   const [windowWidth, setWindowWidth] = useState(0);
//   const [isClient, setIsClient] = useState(false);
//   const history = useHistory();

//   // State for word limit warning dialog
//   const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
//   const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

//   const accessToUpload = useCheckFeatureAccess("paraphraser", "upload");
//   const accessToParaphrase = useCheckFeatureAccess("paraphraser", "paraphrase");
//   const accessToDelete = useCheckFeatureAccess("paraphraser", "delete");
//   const accessToParaphraserScreen =
//     useCheckSubscriptionPlanAccess("Paraphraser");
//   const accessTocustom = useCheckSubscriptionPlanAccess("custom");
//   const [subReqOpen, setSubReqOpen] = useState(false);
//   const [notification, setNotification] = useState({
//     open: false,
//     message: "",
//   });

//   const accessToTone = useCheckSubscriptionPlanAccess("tone");
//   const accessToMoreOptions = useCheckSubscriptionPlanAccess("moreOptions");

//   const fileInputRef = useRef(null);

//   const buttons = [
//     { id: "standard", label: "Standard", icon: "📝" },
//     { id: "formal", label: "Formal", icon: "🎩" },
//     { id: "casual", label: "Casual", icon: "😊" },
//     { id: "positive", label: "Positive", icon: "✨" },
//     { id: "confident", label: "Confident", icon: "💪" },
//     { id: "friendly", label: "Friendly", icon: "🤝" },
//     { id: "simple", label: "Simple", icon: "🔹" },
//   ];

//   const customSuggestions = [
//     { label: "Like a Story", icon: "📖" },
//     { label: "Like a Poem", icon: "✍️" },
//     { label: "Like a CEO", icon: "💼" },
//     { label: "Like a Doctor", icon: "🩺" },
//     { label: "Like a News", icon: "📰" },
//     { label: "Like a Sales Executive", icon: "📊" },
//     { label: "Like a Letter", icon: "✉️" },
//   ];

//   //full screen layout
//   useEffect(() => {
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";
//     return () => { };
//   }, []);

//   useEffect(() => {
//     setIsClient(true);
//     setWindowWidth(window.innerWidth);

//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (
//       !inputText.trim() &&
//       (selectDropdownTone === "shorten" || selectDropdownTone === "expand")
//     ) {
//       setSelectDropdownTone("select");
//     }
//   }, [inputText, selectDropdownTone]);

//   useEffect(() => {
//     if (accessToParaphraserScreen === false) {
//       setSubReqOpen(true);
//     }
//   }, [accessToParaphraserScreen]);

//   useEffect(() => {
//     if (isClient) {
//       getParaphraseLimit();
//     }
//   }, [isClient]);

//   const getParaphraseLimit = async () => {
//     try {
//       let data = await adminServices.getParaphraseLimit();
//       setCharacters({ max: data.paraphrase_limit, now: 0 });
//     } catch (error) {
//       console.error("Error getting paraphrase limit:", error);
//       toast.error("Failed to load paraphrase limits");
//     }
//   };

//   const handleInputChange = (event) => {
//     const text = event.target.value;
//     const length = text.length;

//     if (length > characters.max) {
//       toast.warn(
//         `Character limit exceeded. Maximum ${characters.max} characters allowed.`,
//       );
//       return;
//     }

//     setInputText(text);
//     setCharacters({ ...characters, now: length });

//     if (isParaphrase) {
//       setIsParaphrase(false);
//       setOutputText("");
//     }
//   };

//   const GrammerCheckForParaphrase = async (type) => {
//     setLoading(true);

//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         isCoAuthor: false,
//         ...identity,
//       };

//       if (type && type !== "defaultPrompt") {
//         if (
//           [
//             "Like a story",
//             "Like a poem",
//             "Like a letter",
//             "Like a sales executive",
//             "Like a news",
//             "Like a Doctor",
//             "Like a CEO",
//           ].includes(type)
//         ) {
//           data.tone = "custom";
//           data.customTone = type;
//         } else {
//           data.tone = type;
//         }
//       }

//       const paraphraseResponse = await checkPhrasing(data);

//       if (paraphraseResponse && paraphraseResponse.data) {
//         let outputText = "";

//         if (Array.isArray(paraphraseResponse.data.output)) {
//           outputText = paraphraseResponse.data.output.join("\n");
//         } else if (typeof paraphraseResponse.data.output === "string") {
//           outputText = paraphraseResponse.data.output;
//         } else if (paraphraseResponse.data.paraphrasedText) {
//           outputText = paraphraseResponse.data.paraphrasedText;
//         } else if (paraphraseResponse.data.result) {
//           outputText = paraphraseResponse.data.result;
//         } else {
//           outputText = JSON.stringify(paraphraseResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         try {
//           const logData = {
//             // userId: sessionStorage.getItem("userId"),
//             // organizationId: sessionStorage.getItem("organizationId"),
//             ...identity,
//             actionType: "paraphrase",
//           };
//           await addUserLogs(logData);
//         } catch (logError) {
//           console.error("Error logging user action:", logError);
//         }

//         toast.success("Text paraphrased successfully!");
//       } else {
//         toast.error("No valid response received from the server");
//       }
//     } catch (error) {
//       console.error("Error in GrammerCheckForParaphrase:", error);
//       toast.error("Failed to paraphrase text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkWordsCompression = async () => {
//     setLoading(true);
//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         ...identity,
//       };

//       const wordCompressionResponse = await checkCompression(data);

//       if (wordCompressionResponse && wordCompressionResponse.data) {
//         let outputText = "";

//         if (Array.isArray(wordCompressionResponse.data.output)) {
//           outputText = wordCompressionResponse.data.output.join("\n");
//         } else if (typeof wordCompressionResponse.data.output === "string") {
//           outputText = wordCompressionResponse.data.output;
//         } else {
//           outputText = JSON.stringify(wordCompressionResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         toast.success("Content has been shortened.");
//       } else {
//         toast.error("No response received for compression");
//       }
//     } catch (error) {
//       console.error("Error in checkWordsCompression:", error);
//       toast.error("Failed to compress text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkWordsExpansion = async () => {
//     setLoading(true);
//     try {
//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         setLoading(false);
//         return;
//       }

//       let data = {
//         text: inputText,
//         // userId: userID,
//         ...identity,
//       };

//       const wordExpansionResponse = await checkExpansion(data);

//       if (wordExpansionResponse && wordExpansionResponse.data) {
//         let outputText = "";

//         if (Array.isArray(wordExpansionResponse.data.output)) {
//           outputText = wordExpansionResponse.data.output.join("\n");
//         } else if (typeof wordExpansionResponse.data.output === "string") {
//           outputText = wordExpansionResponse.data.output;
//         } else {
//           outputText = JSON.stringify(wordExpansionResponse.data);
//         }

//         if (outputText.startsWith("\n")) {
//           outputText = outputText.substring(1);
//         }

//         setOutputText(outputText);
//         setIsParaphrase(true);

//         toast.success("The content has been enriched with more details.");
//       } else {
//         toast.error("No response received for expansion");
//       }
//     } catch (error) {
//       console.error("Error in checkWordsExpansion:", error);
//       toast.error("Failed to expand text. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const [isFeatureInside, setIsFeatureInside] = useState(false);

//   // Updated handleFutureButton with word limit check
//   const handleFutureButton = async (type) => {
//     // Check word limit first
//     const wordCount = countWords(inputText);

//     if (wordCount > 1500) {
//       setWordLimitDialogOpen(true);
//       setWordLimitExceeded(true);
//       return;
//     }

//     if (accessToMoreOptions == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }
//     try {
//       if (accessTocustom == false) {
//         setSubReqOpen(true);
//         setIsFeatureInside(true);
//         return;
//       }
//       // const checkailimit = await checkAIRequestLimit(identity);
//       // if (checkailimit === false) {
//       //   toast.warn("AI request limit reached.");
//       //   return;
//       // }

//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         return;
//       }

//       if (type === "shorten") {
//         await checkWordsCompression();
//         setCustomText("Custom");
//       } else if (type === "expand") {
//         await checkWordsExpansion();
//         setCustomText("Custom");
//       } else if (type === "custom") {
//         setIsCustomOpen(true);
//       } else {
//         await GrammerCheckForParaphrase(type);
//         setCustomText("Custom");
//       }
//     } catch (error) {
//       console.error("Error in handleFutureButton:", error);
//       toast.error("An error occurred. Please try again.");
//     }
//   };

//   // Updated onPetAssistant with word limit check
//   const onPetAssistant = async () => {
//     // Check word limit first
//     const wordCount = countWords(inputText);

//     if (wordCount > 1500) {
//       setWordLimitDialogOpen(true);
//       setWordLimitExceeded(true);
//       return;
//     }

//     try {
//       // const checkailimit = await checkAIRequestLimit(identity);
//       // if (checkailimit === false) {
//       //   toast.warn("AI request limit reached.");
//       //   return;
//       // }

//       if (!inputText.trim()) {
//         toast.warning("Please input some text!");
//         return;
//       }

//       await GrammerCheckForParaphrase("standard");
//     } catch (error) {
//       console.error("Error in onPetAssistant:", error);
//       toast.error("An error occurred while processing your request.");
//     }
//   };

//   // Handle word limit dialog close
//   const handleWordLimitDialogClose = () => {
//     setWordLimitDialogOpen(false);
//     setWordLimitExceeded(false);
//   };

//   const handleDelete1 = () => {
//     setInputText("");
//     setOutputText("");
//     setIsParaphrase(false);
//     setCharacters({ ...characters, now: 0 });
//   };

//   const handleDelete = () => {
//     setOutputText("");
//     setIsParaphrase(false);
//   };

//   const handleCopy = () => {
//     if (!outputText.trim()) {
//       toast.warn("No text to copy");
//       return;
//     }

//     navigator.clipboard.writeText(outputText).then(
//       () => {
//         toast.success("Text copied to clipboard!");
//       },
//       (err) => {
//         console.error("Could not copy text: ", err);
//         toast.error("Failed to copy text");
//       },
//     );
//   };

//   const handleDownload = () => {
//     if (!outputText.trim()) {
//       toast.warn("No text to download");
//       return;
//     }

//     const blob = new Blob([outputText], { type: "text/plain" });
//     const anchor = document.createElement("a");
//     anchor.href = URL.createObjectURL(blob);
//     anchor.download = "paraphrased_text.txt";
//     anchor.click();
//     URL.revokeObjectURL(anchor.href);
//     toast.success("File downloaded successfully!");
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (!file.name.endsWith(".txt")) {
//       toast.warn("Only .txt files are supported");
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const text = event.target.result;
//       const wordCount = countWords(text);

//       if (wordCount > 1500) {
//         toast.warn("File content exceeds 1500 word limit");
//         return;
//       }

//       setInputText(text);
//       toast.success("File uploaded successfully!");
//     };

//     reader.onerror = () => {
//       toast.error("Failed to read file");
//     };

//     reader.readAsText(file);
//   };

//   const handleCustomSelection = (type) => {
//     if (!inputText.trim()) {
//       toast.warning("Please input some text!");
//       return;
//     }

//     GrammerCheckForParaphrase(type);
//     setCustomText(type);
//     setIsCustomOpen(false);
//     setCustomTextValue("");
//   };

//   const handleCustomClick = () => {
//     if (!customTextValue.trim()) {
//       toast.warning("Please enter a custom tone");
//       return;
//     }

//     handleCustomSelection(customTextValue);
//   };

//   const handleSuggestionChange = (e) => {
//     setCustomTextValue(e.target.value);
//   };

//   const handleClose = () => {
//     setIsCustomOpen(false);
//     setCustomTextValue("");
//   };
//   const handleBreadcrumbClick = (event, path) => {
//     event.preventDefault();
//     history.push(path);
//   };
//   const handleToneClick = (toneId) => {
//     if (accessToTone == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }
//     setSelectedTone(toneId);
//     handleFutureButton(toneId);
//   };

//   const countWords = (text) => {
//     return text.trim().length > 0 ? text.trim().split(/\s+/).length : 0;
//   };

//   const inputWordCount = countWords(inputText);
//   const outputWordCount = countWords(outputText);

//   const renderSelect = () => {
//     if (!isClient) return null;

//     return (
//       <FormControl size="small" sx={{ minWidth: 100 }}>
//         <Select
//           value={selectDropdownTone}
//           onChange={(e) => {
//             const selectedValue = e.target.value;
//             if (selectedValue !== "select") {
//               handleFutureButton(selectedValue);
//               setSelectedTone(selectedValue);
//               setSelectDropdownTone(selectedValue);
//             }
//           }}
//           displayEmpty
//           sx={{
//             borderRadius: 2,
//             height: 36,
//             "& .MuiSelect-select": {
//               display: "flex",
//               alignItems: "center",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             },
//           }}
//           MenuProps={{
//             PaperProps: {
//               sx: {
//                 maxHeight: 300,
//                 "& .MuiMenuItem-root": {
//                   minHeight: 36,
//                   display: "flex",
//                   alignItems: "center",
//                 },
//               },
//             },
//           }}
//         >
//           <MenuItem value="select">More Options</MenuItem>
//           <MenuItem
//             disabled={!accessToParaphrase || !inputText.trim()}
//             value="shorten"
//           >
//             🔽 Shorten
//           </MenuItem>
//           <MenuItem
//             disabled={!accessToParaphrase || !inputText.trim()}
//             value="expand"
//           >
//             🔼 Expand
//           </MenuItem>
//         </Select>
//       </FormControl>
//     );
//   };

//   if (!isClient) {
//     return (
//       <Box
//         sx={{
//           height: "95vh",
//           display: "flex",
//           flexDirection: "column",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #e7ecf4ff 100%)",
//           overflow: "hidden",
//         }}
//       >
//         <Loader loading={true} />
//       </Box>
//     );
//   }

//   return (
//     <>
//       <SubscriptionRequired
//         open={subReqOpen}
//         setOpen={setSubReqOpen}
//         isFeatureInside={isFeatureInside}
//         setIsFeatureInside={setIsFeatureInside}
//         path={"paraphrase"}
//       />

//       {/* Word Limit Warning Dialog - with high z-index */}
//       <Dialog
//         open={wordLimitDialogOpen}
//         onClose={handleWordLimitDialogClose}
//         aria-labelledby="word-limit-dialog-title"
//         aria-describedby="word-limit-dialog-description"
//         sx={{
//           zIndex: 100000,
//           '& .MuiDialog-container': {
//             zIndex: 100000,
//           },
//           '& .MuiDialog-paper': {
//             zIndex: 100001,
//             borderRadius: 3,
//             padding: 2,
//             minWidth: 400,
//           }
//         }}
//       >
//         <DialogTitle 
//           id="word-limit-dialog-title"
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//             color: '#ef4444',
//             fontWeight: 600
//           }}
//         >
//           <WarningIcon sx={{ fontSize: 28 }} />
//           Word Limit Exceeded
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText 
//             id="word-limit-dialog-description"
//             sx={{
//               color: '#4b5563',
//               fontSize: '1rem'
//             }}
//           >
//             You have entered <strong>{inputWordCount}</strong> words, which exceeds the maximum limit of <strong>1500 words</strong>.
//           </DialogContentText>
//           <Box sx={{ mt: 2, p: 2, bgcolor: '#f3f4f6', borderRadius: 2 }}>
//             <Typography variant="body2" sx={{ color: '#1f2937' }}>
//               Please reduce your text to 1500 words or less to continue with paraphrasing.
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button 
//             onClick={handleWordLimitDialogClose}
//             variant="contained"
//             sx={{
//               bgcolor: '#ef4444',
//               '&:hover': {
//                 bgcolor: '#dc2626'
//               },
//               borderRadius: 2,
//               px: 4
//             }}
//           >
//             OK, Got it
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ToastContainer with high z-index */}
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         style={{ zIndex: 99999 }}
//         containerStyle={{ zIndex: 99999 }}
//       />

//       <Box
//         sx={{
//           position: "fixed",
//           inset: 0,
//           zIndex: 9998,
//           overflowY: "auto",
//           overflowX: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
//         }}
//       >
//         <Loader loading={loading} />
//         <Container
//           maxWidth="xl"
//           disableGutters
//           sx={{
//             flex: 1,
//             display: "flex",
//             flexDirection: "column",
//             minHeight: "100%",
//             px: 1,
//             py: 1,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               position: "relative",
//               width: "100%",
//             }}
//           >
//             {/* LEFT SIDE - Breadcrumb */}
//             <Box sx={{ display: "flex", alignItems: "center", mt: 1, p: 1 }}>
//               <Paper
//                 elevation={1}
//                 sx={{
//                   p: 1.5,
//                   bgcolor: "white",
//                   borderRadius: 3,
//                   border: "1px solid",
//                   borderColor: "divider",
//                   transition: "all 0.3s ease",
//                   "&:hover": {
//                     boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
//                   },
//                 }}
//               >
//                 <Breadcrumbs
//                   separator={
//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />
//                   }
//                   aria-label="breadcrumb"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     flexWrap: "nowrap",
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

//                     <Link
//                       to="/docTags"
//                       onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
//                       style={{
//                         textDecoration: "none",
//                         color: "#667eea",
//                         fontWeight: 500,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       MultiTool AI
//                     </Link>

//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />

//                     <Typography
//                       sx={{
//                         color: "#1a1a1a",
//                         fontWeight: 600,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         backgroundColor: "rgba(102, 126, 234, 0.08)",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       AI Paraphraser
//                     </Typography>
//                   </Box>
//                 </Breadcrumbs>
//               </Paper>
//             </Box>

//             {/* CENTER CONTENT */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 textAlign: "center",
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <AutoFixHigh sx={{ fontSize: 36, color: "primary.main" }} />
//                 <Box>
//                   <Typography
//                     sx={{
//                       fontSize: 22,
//                       fontWeight: 700,
//                       color: "primary.main",
//                     }}
//                   >
//                     AI Paraphraser
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{ color: "text.secondary", fontStyle: "italic" }}
//                   >
//                     Transform your text with intelligent rephrasing powered by
//                     AI
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           <Box sx={{ flexShrink: 0, p: 1 }}>
//             <Card
//               elevation={0}
//               sx={{
//                 borderRadius: 3,
//                 background: "rgba(255, 255, 255, 0.95)",
//                 backdropFilter: "blur(10px)",
//                 border: "1px solid rgba(255, 255, 255, 0.3)",
//               }}
//             >
//               <CardContent sx={{ pb: 2, "&:last-child": { pb: 2 } }}>
//                 <Box sx={{ mb: 1 }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight={600}
//                   >
//                     Output Format
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                   >
//                     Select how you want to display the paraphrased content
//                   </Typography>
//                 </Box>

//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     gap: 1.5,
//                     alignItems: "center",
//                     minHeight: 40,
//                   }}
//                 >
//                   {buttons.map((button) => (
//                     <Chip
//                       key={button.id}
//                       icon={
//                         <span style={{ fontSize: "16px" }}>{button.icon}</span>
//                       }
//                       label={button.label}
//                       disabled={!inputText || !accessToParaphrase}
//                       onClick={() => handleToneClick(button.id)}
//                       color={selectedTone === button.id ? "primary" : "default"}
//                       variant={selectedTone === button.id ? "filled" : "outlined"}
//                       sx={{
//                         height: "36px",
//                         fontSize: "0.85rem",
//                         fontWeight: 600,
//                         transition: "all 0.3s",
//                         cursor: "pointer",
//                         "&:hover": {
//                           transform: "scale(1.05)",
//                           boxShadow: 2,
//                         },
//                       }}
//                     />
//                   ))}

//                   <Box
//                     sx={{
//                       ml: "auto",
//                       display: "flex",
//                       gap: 1,
//                       flexWrap: "wrap",
//                       alignItems: "center",
//                     }}
//                   >
//                     {renderSelect()}

//                     <Button
//                       variant="contained"
//                       onClick={() => handleFutureButton("custom")}
//                       disabled={!accessToParaphrase || !inputText.trim()}
//                       startIcon={<Tune />}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         height: 36,
//                         minWidth: 100,
//                         background: inputWordCount > 1500 
//                           ? "#ef4444" 
//                           : "linear-gradient(45deg, #667eea, #764ba2)",
//                         '&:hover': {
//                           background: inputWordCount > 1500 
//                             ? "#dc2626" 
//                             : "linear-gradient(45deg, #764ba2, #667eea)",
//                         }
//                       }}
//                     >
//                       {customText}
//                     </Button>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>

//           <Box sx={{ flexGrow: 1, px: 1, pb: 3, minHeight: 0 }}>
//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
//                 gap: 3,
//                 minHeight: "500px",
//               }}
//             >
//               <Card
//                 elevation={4}
//                 sx={{
//                   height: "100%",
//                   borderRadius: 3,
//                   background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     bgcolor: "primary.main",
//                     color: "white",
//                     p: 2,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 2,
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     sx={{ fontWeight: 600, flexGrow: 1 }}
//                   >
//                     📝 Input Text
//                   </Typography>
//                   <Chip
//                     label={`${inputWordCount} Words`}
//                     size="small"
//                     sx={{
//                       bgcolor: inputWordCount > 1500 ? "#ef4444" : "rgba(255,255,255,0.2)",
//                       color: "white",
//                       fontWeight: 600,
//                     }}
//                   />
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     minHeight: "400px",
//                     maxHeight: "400px",
//                     overflow: "scroll",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       flex: 1,
//                       p: 2,
//                       overflow: "auto",
//                       height: "350px",
//                       "&::-webkit-scrollbar": {
//                         width: "8px",
//                       },
//                       "&::-webkit-scrollbar-track": {
//                         background: "#f5f5f5",
//                         borderRadius: "4px",
//                       },
//                       "&::-webkit-scrollbar-thumb": {
//                         background: "#c1c1c1",
//                         borderRadius: "4px",
//                         "&:hover": {
//                           background: "#a8a8a8",
//                         },
//                       },
//                     }}
//                   >
//                     <TextField
//                       multiline
//                       fullWidth
//                       value={inputText}
//                       onChange={handleInputChange}
//                       placeholder="✨ Start typing or paste your text here to paraphrase..."
//                       variant="outlined"
//                       InputProps={{
//                         sx: {
//                           fontSize: "15px",
//                           lineHeight: 1.6,
//                           minHeight: "320px",
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&:hover .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                         },
//                       }}
//                       sx={{
//                         "& .MuiInputBase-root": {
//                           minHeight: "320px",
//                           alignItems: "flex-start",
//                         },
//                         "& textarea": {
//                           overflow: "auto !important",
//                           minHeight: "300px !important",
//                           resize: "none",
//                         },
//                       }}
//                     />
//                   </Box>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: "black.50",
//                     borderTop: "1px solid",
//                     borderColor: "divider",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <Circle
//                       sx={{
//                         fontSize: 10,
//                         color: inputWordCount > 1500 ? "error.main" : "success.main",
//                       }}
//                     />
//                     <Typography
//                       variant="caption"
//                       sx={{ fontWeight: 600, color: "text.secondary" }}
//                     >
//                       {inputWordCount} / 1500 Words
//                     </Typography>
//                   </Box>

//                   <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                     <Button
//                       component="label"
//                       variant="outlined"
//                       size="small"
//                       disabled={!accessToUpload}
//                       startIcon={<CloudUpload />}
//                       sx={{ borderRadius: 2, textTransform: "none" }}
//                     >
//                       Upload
//                       <input
//                         ref={fileInputRef}
//                         type="file"
//                         accept=".txt"
//                         hidden
//                         onChange={handleFileUpload}
//                       />
//                     </Button>

//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={onPetAssistant}
//                       disabled={!inputText || !accessToParaphrase}
//                       startIcon={<AutoFixHigh />}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         background: inputWordCount > 1500 
//                           ? "#ef4444" 
//                           : "linear-gradient(45deg, #667eea, #764ba2)",
//                         '&:hover': {
//                           background: inputWordCount > 1500 
//                             ? "#dc2626" 
//                             : "linear-gradient(45deg, #764ba2, #667eea)",
//                         }
//                       }}
//                     >
//                       {!isParaphrase ? "Paraphrase" : "Re-Phrase"}
//                     </Button>

//                     <IconButton
//                       size="small"
//                       onClick={handleDelete1}
//                       disabled={!accessToDelete}
//                       sx={{
//                         color: accessToDelete ? "error.main" : "black.500",
//                       }}
//                     >
//                       <Delete />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               </Card>

//               <Card
//                 elevation={4}
//                 sx={{
//                   height: "100%",
//                   borderRadius: 3,
//                   background: "linear-gradient(145deg, #ffffff 0%, #e8f5e9 100%)",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     bgcolor: "success.main",
//                     color: "white",
//                     p: 2,
//                     borderRadius: "12px 12px 0 0",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                     ✨ Paraphrased Result
//                   </Typography>
//                   <Chip
//                     label={`${outputWordCount} Words`}
//                     size="small"
//                     sx={{
//                       bgcolor: "rgba(255,255,255,0.2)",
//                       color: "white",
//                       fontWeight: 600,
//                     }}
//                   />
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     minHeight: "400px",
//                     maxHeight: "400px",
//                     overflow: "scroll",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       flex: 1,
//                       p: 2,
//                       overflow: "auto",
//                       maxHeight: "100%",
//                       "&::-webkit-scrollbar": {
//                         width: "8px",
//                       },
//                       "&::-webkit-scrollbar-track": {
//                         background: "#f5f5f5",
//                         borderRadius: "4px",
//                       },
//                       "&::-webkit-scrollbar-thumb": {
//                         background: "#c1c1c1",
//                         borderRadius: "4px",
//                         "&:hover": {
//                           background: "#a8a8a8",
//                         },
//                       },
//                     }}
//                   >
//                     <TextField
//                       multiline
//                       fullWidth
//                       value={outputText}
//                       placeholder="Your paraphrased text will appear here..."
//                       variant="outlined"
//                       InputProps={{
//                         readOnly: true,
//                         sx: {
//                           fontSize: "15px",
//                           lineHeight: 1.6,
//                           minHeight: "300px",
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&:hover .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                             border: "none",
//                           },
//                         },
//                       }}
//                       sx={{
//                         "& .MuiInputBase-root": {
//                           minHeight: "300px",
//                           alignItems: "flex-start",
//                         },
//                         "& textarea": {
//                           overflow: "auto !important",
//                           minHeight: "300px !important",
//                           resize: "none",
//                         },
//                       }}
//                     />
//                   </Box>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: "black.50",
//                     borderTop: "1px solid",
//                     borderColor: "divider",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <Circle sx={{ fontSize: 10, color: "success.main" }} />
//                     <Typography
//                       variant="caption"
//                       sx={{ fontWeight: 600, color: "text.secondary" }}
//                     >
//                       {outputWordCount} Words Generated
//                     </Typography>
//                   </Box>

//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <IconButton
//                       size="small"
//                       onClick={handleDownload}
//                       disabled={!outputWordCount}
//                       sx={{
//                         color: outputWordCount ? "success.main" : "black.500",
//                       }}
//                     >
//                       <Download />
//                     </IconButton>

//                     <IconButton
//                       size="small"
//                       onClick={handleCopy}
//                       disabled={!outputWordCount}
//                       sx={{
//                         color: outputWordCount ? "info.main" : "black.500",
//                       }}
//                     >
//                       <ContentCopy />
//                     </IconButton>

//                     <IconButton
//                       size="small"
//                       onClick={handleDelete}
//                       disabled={!accessToDelete || !outputWordCount}
//                       sx={{
//                         color:
//                           accessToDelete && outputWordCount
//                             ? "error.main"
//                             : "black.500",
//                       }}
//                     >
//                       <Delete />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>
//           </Box>
//         </Container>
//       </Box>
//     </>
//   );
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
//   features: state.features.features,
// });

// export default connect(mapStateToProps)(NewParaphrase);





import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Paper,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Select,
  MenuItem,
  Container,
  FormControl,
  Breadcrumbs,
} from "@mui/material";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  ContentCopy,
  Download,
  Delete,
  CloudUpload,
  AutoFixHigh,
  Tune,
  Circle,
  Warning as WarningIcon,
} from "@mui/icons-material";
import InputBoxMui from "../ReusableComponents/InputBoxMui";
import FeatureButton from "../ReusableComponents/Button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkCompression,
  checkExpansion,
  checkPhrasing,
} from "../../services/englishCheckers";
import Loader from "../../utils/loader";
import { connect } from "react-redux";
import adminServices from "../../services/adminServices";
import { useSelector } from "react-redux";
import { addUserLogs } from "../../services/userLogServices";
import { useCheckFeatureAccess } from "../CheckFeature";
import SubscriptionRequired from "../SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";

function NewParaphrase({ features, trial = false }) {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const userDetails = useSelector((state) => state.user);

  // const userID = userDetails?.currentUser?._id || "";
  const token = sessionStorage.getItem("token");

  const getIdentityFromToken = () => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      if (decoded.role === "guest") {
        return { machineId: decoded.machineId };
      } else {
        return { userId: decoded._id };
      }
    } catch (err) {
      console.error("Invalid token");
      return null;
    }
  };

  const identity = getIdentityFromToken();
  const [characters, setCharacters] = useState({ max: 1500, now: 0 });
  const [loading, setLoading] = useState(false);
  const [isParaphrase, setIsParaphrase] = useState(false);
  const [isCustomOpen, setIsCustomOpen] = useState(false);
  const [customText, setCustomText] = useState("Custom");
  const [customTextValue, setCustomTextValue] = useState("");
  const [selectedTone, setSelectedTone] = useState("standard");
  const [selectDropdownTone, setSelectDropdownTone] = useState("select");
  const [windowWidth, setWindowWidth] = useState(0);
  const [isClient, setIsClient] = useState(false);
  const history = useHistory();

  // State for word limit warning dialog
  const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

  const accessToUpload = useCheckFeatureAccess("paraphraser", "upload");
  const accessToParaphrase = useCheckFeatureAccess("paraphraser", "paraphrase");
  const accessToDelete = useCheckFeatureAccess("paraphraser", "delete");
  const accessToParaphraserScreen =
    useCheckSubscriptionPlanAccess("Paraphraser");
  //const accessTocustom = useCheckSubscriptionPlanAccess("custom");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
  });

  const accessTocustom = true;

  // const accessToTone = useCheckSubscriptionPlanAccess("tone");
  // const accessToMoreOptions = useCheckSubscriptionPlanAccess("moreOptions");

  const accessToTone = true;
  const accessToMoreOptions = true;

  const fileInputRef = useRef(null);

  const [suggestionText, setSuggestionText] = useState("Custom")
  const [isCustomSuggestion, setIsCustomSuggestion] = useState(true)

  const buttons = [
    { id: "standard", label: "Standard", icon: "📝" },
    { id: "formal", label: "Formal", icon: "🎩" },
    { id: "casual", label: "Casual", icon: "😊" },
    { id: "positive", label: "Positive", icon: "✨" },
    { id: "confident", label: "Confident", icon: "💪" },
    { id: "friendly", label: "Friendly", icon: "🤝" },
    { id: "simple", label: "Simple", icon: "🔹" },
  ];

  const customSuggestions = [
    { label: "Like a Story", icon: "📖" },
    { label: "Like a Poem", icon: "✍️" },
    { label: "Like a CEO", icon: "💼" },
    { label: "Like a Doctor", icon: "🩺" },
    { label: "Like a News", icon: "📰" },
    { label: "Like a Sales Executive", icon: "📊" },
    { label: "Like a Letter", icon: "✉️" },
  ];

  //full screen layout
  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100vh";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.height = "";
      document.body.style.overflow = "";
      document.documentElement.style.height = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  useEffect(() => {
  if (!inputText.trim()) {
    // When input becomes empty, reset the tone-related states
    setSelectDropdownTone("select");
    setCustomText("Custom");
    setSelectedTone("standard");
  }
}, [inputText]);

  useEffect(() => {
    setIsClient(true);
    setWindowWidth(window.innerWidth);

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      !inputText.trim() &&
      (selectDropdownTone === "shorten" || selectDropdownTone === "expand")
    ) {
      setSelectDropdownTone("select");
    }
  }, [inputText, selectDropdownTone]);

  useEffect(() => {
    if (accessToParaphraserScreen === false) {
      setSubReqOpen(true);
    }
  }, [accessToParaphraserScreen]);

  useEffect(() => {
    if (isClient) {
      getParaphraseLimit();
    }
  }, [isClient]);

  const getParaphraseLimit = async () => {
    try {
      let data = await adminServices.getParaphraseLimit();
      setCharacters({ max: data.paraphrase_limit, now: 0 });
    } catch (error) {
      console.error("Error getting paraphrase limit:", error);
      toast.error("Failed to load paraphrase limits");
    }
  };

  const handleInputChange = (event) => {
    const text = event.target.value;
    const length = text.length;

    if (length > characters.max) {
      toast.warn(
        `Character limit exceeded. Maximum ${characters.max} characters allowed.`,
      );
      return;
    }

    setInputText(text);
    setCharacters({ ...characters, now: length });

    if (isParaphrase) {
      setIsParaphrase(false);
      setOutputText("");
    }
  };

  const GrammerCheckForParaphrase = async (type) => {
    setLoading(true);

    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        // userId: userID,
        isCoAuthor: false,
        ...identity,
      };

      if (type && type !== "defaultPrompt") {
        if (
          [
            "Like a story",
            "Like a poem",
            "Like a letter",
            "Like a sales executive",
            "Like a news",
            "Like a Doctor",
            "Like a CEO",
          ].includes(type)
        ) {
          data.tone = "custom";
          data.customTone = type;
        } else {
          data.tone = type;
        }
      }

      const paraphraseResponse = await checkPhrasing(data);

      if (paraphraseResponse && paraphraseResponse.data) {
        let outputText = "";

        if (Array.isArray(paraphraseResponse.data.output)) {
          outputText = paraphraseResponse.data.output.join("\n");
        } else if (typeof paraphraseResponse.data.output === "string") {
          outputText = paraphraseResponse.data.output;
        } else if (paraphraseResponse.data.paraphrasedText) {
          outputText = paraphraseResponse.data.paraphrasedText;
        } else if (paraphraseResponse.data.result) {
          outputText = paraphraseResponse.data.result;
        } else {
          outputText = JSON.stringify(paraphraseResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);

        try {
          const logData = {
            // userId: sessionStorage.getItem("userId"),
            // organizationId: sessionStorage.getItem("organizationId"),
            ...identity,
            actionType: "paraphrase",
          };
          await addUserLogs(logData);
        } catch (logError) {
          console.error("Error logging user action:", logError);
        }

        toast.success("Text paraphrased successfully!");
      } else {
        toast.error("No valid response received from the server");
      }
    } catch (error) {
      console.error("Error in GrammerCheckForParaphrase:", error);
      toast.error("Failed to paraphrase text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkWordsCompression = async () => {
    setLoading(true);
    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        // userId: userID,
        ...identity,
      };

      const wordCompressionResponse = await checkCompression(data);

      if (wordCompressionResponse && wordCompressionResponse.data) {
        let outputText = "";

        if (Array.isArray(wordCompressionResponse.data.output)) {
          outputText = wordCompressionResponse.data.output.join("\n");
        } else if (typeof wordCompressionResponse.data.output === "string") {
          outputText = wordCompressionResponse.data.output;
        } else {
          outputText = JSON.stringify(wordCompressionResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);

        toast.success("Content has been shortened.");
      } else {
        toast.error("No response received for compression");
      }
    } catch (error) {
      console.error("Error in checkWordsCompression:", error);
      toast.error("Failed to compress text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkWordsExpansion = async () => {
    setLoading(true);
    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        // userId: userID,
        ...identity,
      };

      const wordExpansionResponse = await checkExpansion(data);

      if (wordExpansionResponse && wordExpansionResponse.data) {
        let outputText = "";

        if (Array.isArray(wordExpansionResponse.data.output)) {
          outputText = wordExpansionResponse.data.output.join("\n");
        } else if (typeof wordExpansionResponse.data.output === "string") {
          outputText = wordExpansionResponse.data.output;
        } else {
          outputText = JSON.stringify(wordExpansionResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);

        toast.success("The content has been enriched with more details.");
      } else {
        toast.error("No response received for expansion");
      }
    } catch (error) {
      console.error("Error in checkWordsExpansion:", error);
      toast.error("Failed to expand text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [isFeatureInside, setIsFeatureInside] = useState(false);

  // Updated handleFutureButton with word limit check
  const handleFutureButton = async (type) => {
    // Check word limit first
    const wordCount = countWords(inputText);

    if (wordCount > 1500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    if (accessToMoreOptions == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    try {
      if (accessTocustom == false) {
        setSubReqOpen(true);
        setIsFeatureInside(true);
        return;
      }
      // const checkailimit = await checkAIRequestLimit(identity);
      // if (checkailimit === false) {
      //   toast.warn("AI request limit reached.");
      //   return;
      // }

      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        return;
      }

      if (type === "shorten") {
        await checkWordsCompression();
        setCustomText("Custom");
      } else if (type === "expand") {
        await checkWordsExpansion();
        setCustomText("Custom");
      } else if (type === "custom") {
        setIsCustomOpen(true);
      } else {
        await GrammerCheckForParaphrase(type);
        setCustomText("Custom");
      }
    } catch (error) {
      console.error("Error in handleFutureButton:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  // Updated onPetAssistant with word limit check
  const onPetAssistant = async () => {
    // Check word limit first
    const wordCount = countWords(inputText);

    if (wordCount > 1500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    try {
      // const checkailimit = await checkAIRequestLimit(identity);
      // if (checkailimit === false) {
      //   toast.warn("AI request limit reached.");
      //   return;
      // }

      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        return;
      }

      await GrammerCheckForParaphrase("standard");
    } catch (error) {
      console.error("Error in onPetAssistant:", error);
      toast.error("An error occurred while processing your request.");
    }
  };

  // Handle word limit dialog close
  const handleWordLimitDialogClose = () => {
    setWordLimitDialogOpen(false);
    setWordLimitExceeded(false);
  };

  const handleDelete1 = () => {
    setInputText("");
    setOutputText("");
    setIsParaphrase(false);
    setCharacters({ ...characters, now: 0 });
    setSelectDropdownTone("select");
    setCustomText("Custom");
    setSelectedTone("standard");
  };

  const handleDelete = () => {
    setOutputText("");
    setIsParaphrase(false);
  };

  const handleCopy = () => {
    if (!outputText.trim()) {
      toast.warn("No text to copy");
      return;
    }

    navigator.clipboard.writeText(outputText).then(
      () => {
        toast.success("Text copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
        toast.error("Failed to copy text");
      },
    );
  };

  const handleDownload = () => {
    if (!outputText.trim()) {
      toast.warn("No text to download");
      return;
    }

    const blob = new Blob([outputText], { type: "text/plain" });
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "paraphrased_text.txt";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    toast.success("File downloaded successfully!");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".txt")) {
      toast.warn("Only .txt files are supported");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      const wordCount = countWords(text);

      if (wordCount > 1500) {
        toast.warn("File content exceeds 1500 word limit");
        return;
      }

      setInputText(text);
      toast.success("File uploaded successfully!");
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
    };

    reader.readAsText(file);
  };

  const handleCustomSelection = (type) => {
    if (!inputText.trim()) {
      toast.warning("Please input some text!");
      return;
    }

    GrammerCheckForParaphrase(type);
    setCustomText(type);
    setIsCustomOpen(false);
    setCustomTextValue("");
  };

  const handleCustomClick = () => {
    if (!customTextValue.trim()) {
      toast.warning("Please enter a custom tone");
      return;
    }

    handleCustomSelection(customTextValue);
  };

  const handleSuggestionChange = (e) => {
    setCustomTextValue(e.target.value);
  };

  const handleClose = () => {
    setIsCustomOpen(false);
    setCustomTextValue("");
  };
  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
     window.location.href = "/docTags";
    // history.push(path);
  };
  const handleToneClick = (toneId) => {
    if (accessToTone == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    setSelectedTone(toneId);
    handleFutureButton(toneId);
  };

  const countWords = (text) => {
    return text.trim().length > 0 ? text.trim().split(/\s+/).length : 0;
  };

  const inputWordCount = countWords(inputText);
  const outputWordCount = countWords(outputText);

  const renderSelect = () => {
    if (!isClient) return null;

    return (
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={selectDropdownTone}
          onChange={(e) => {
            const selectedValue = e.target.value;
            if (selectedValue !== "select") {
              handleFutureButton(selectedValue);
              setSelectedTone(selectedValue);
              setSelectDropdownTone(selectedValue);
            }
          }}
          displayEmpty
          sx={{
            borderRadius: 2,
            height: 36,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                "& .MuiMenuItem-root": {
                  minHeight: 36,
                  display: "flex",
                  alignItems: "center",
                },
              },
            },
          }}
        >
          <MenuItem value="select">More Options</MenuItem>
          <MenuItem
            disabled={!accessToParaphrase || !inputText.trim()}
            value="shorten"
          >
            🔽 Shorten
          </MenuItem>
          <MenuItem
            disabled={!accessToParaphrase || !inputText.trim()}
            value="expand"
          >
            🔼 Expand
          </MenuItem>
        </Select>
      </FormControl>
    );
  };



  if (!isClient) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e7ecf4ff 100%)",
          overflow: "hidden",
        }}
      >
        <Loader loading={true} />
      </Box>
    );
  }

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"paraphrase"}
      />

      {/* <Modal
        isOpen={isCustomOpen}
        // toggle={() => setIsCustomOpen(true)}
        style={{
          // position: "absolute",
          // left: "43%",
          top: "33%",
        }}
      >
        <ModalHeader toggle={handleClose}>
          <div className="d-flex px-2 justify-content-between">
            <div
              className="custom-heading"
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: "1rem",
              }}
            >Make my text sound...</div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-between">
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                color: "#303030",
                fontSize: "1rem",
              }}
              className="col-md-10"
            >
              <InputBoxMui
                fullWidth
                placeholder={"E.g., “like a News”"}
                value={customTextValue}
                onChange={e => handleSuggestionChange(e)}

              />
            </p>
            <div className="ml-2">
              <button
                className="btn btn-primary"
                onClick={handleCustomClick}
                disabled={customTextValue !== "" ? false : true}
              >
                Done
              </button>
            </div>
          </div>
          <div className="px-2">
            <div
              className="custom-heading"
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >Suggestions:</div>
            <div className="d-flex justify-content-evenly mt-2">
              <FeatureButton text={"Like a Story"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a story")} />
              <FeatureButton text={"Like a Poem"} divClassName={"ml-3"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a poem")} />
            </div>
            <div className="d-flex justify-content-evenly mt-2">
              <FeatureButton text={"Like a Ceo"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a CEO")} />
              <FeatureButton text={"Like a Doctor"} divClassName={"ml-3"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a Doctor")} />
            </div>
            <div className="d-flex justify-content-evenly mt-2">
              <FeatureButton text={"Like a News"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a news")} />
              <FeatureButton text={"Like a Sales Executive"} divClassName={"ml-3"} style={{ width: windowWidth < 400 ? '130px' : "160px" }} size={"md"} onClick={() => handleCustomSelection("Like a sales executive")} />
            </div>
            <div className="d-flex justify-content-evenly mt-2">
              <FeatureButton text={"Like a Letter"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection("Like a letter")} />
              <FeatureButton text={suggestionText} disable={isCustomSuggestion} divClassName={"ml-3"} style={{ width: "120px" }} size={"md"} onClick={() => handleCustomSelection(suggestionText)} />
            </div>
          </div>
        </ModalBody>
      </Modal> */}

      <Modal
        isOpen={isCustomOpen}
        toggle={handleClose}
        centered
        contentClassName="custom-style-modal"
      >
        <ModalBody className="p-0">

          {/* Header Section */}
          <div className="style-header">
            <div className="style-title">
              ✨ Transform Your Tone
            </div>
            <div className="style-subtitle">
              Choose a vibe or create your own
            </div>
            <button className="close-btn" onClick={handleClose}>×</button>
          </div>

          <div className="style-content">

            {/* Custom Input */}
            <div className="custom-input-card">
              <InputBoxMui
                fullWidth
                placeholder="E.g., “like a News”"
                value={customTextValue}
                onChange={handleSuggestionChange}
              />
              <button
                className="apply-btn"
                onClick={handleCustomClick}
                disabled={!customTextValue}
              >
                Apply Style
              </button>
            </div>

            {/* Divider */}
            <div className="divider">
              <span>OR PICK A STYLE</span>
            </div>

            {/* Style Grid */}
            <div className="style-grid">
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a story")}
              >
                Storytelling
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a poem")}
              >
                Poetic
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a CEO")}
              >
                CEO Brief
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a Doctor")}
              >
                Medical Expert
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a news")}
              >
                Breaking News
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a sales executive")}
              >
                Sales Pitch
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a letter")}
              >
                Formal Letter
              </div>
              <div
                className={`style-pill ${isCustomSuggestion ? "disabled" : ""}`}
                onClick={() => !isCustomSuggestion && handleCustomSelection(suggestionText)}
              >
                {suggestionText}
              </div>
            </div>

          </div>

          <style jsx>{`
      .custom-style-modal {
        border-radius: 20px;
        overflow: hidden;
        backdrop-filter: blur(20px);
        background: rgba(255, 255, 255, 0.95);
      }

      .style-header {
        background: linear-gradient(135deg, #6366f1, #8b5cf6);
        color: white;
        padding: 24px;
        position: relative;
      }

      .style-title {
        font-size: 1.3rem;
        font-weight: 600;
        font-family: 'Poppins', sans-serif;
      }

      .style-subtitle {
        font-size: 0.9rem;
        opacity: 0.85;
        margin-top: 4px;
        font-family: 'Poppins', sans-serif;
      }

      .close-btn {
        position: absolute;
        right: 16px;
        top: 12px;
        border: none;
        background: transparent;
        font-size: 24px;
        color: white;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.2s ease;
      }

      .close-btn:hover {
        background: rgba(255, 255, 255, 0.2);
      }

      .style-content {
        padding: 24px;
      }

      .custom-input-card {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
      }

      .apply-btn {
        background: #6366f1;
        border: none;
        padding: 10px 18px;
        border-radius: 10px;
        color: white;
        font-weight: 500;
        transition: 0.2s ease;
        cursor: pointer;
        font-family: 'Poppins', sans-serif;
        white-space: nowrap;
      }

      .apply-btn:hover:not(:disabled) {
        background: #4f46e5;
        transform: translateY(-2px);
      }

      .apply-btn:disabled {
        background: #a5b4fc;
        cursor: not-allowed;
        opacity: 0.6;
      }

      .divider {
        text-align: center;
        margin: 20px 0;
        font-size: 0.75rem;
        color: #888;
        position: relative;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
      }

      .divider::before,
      .divider::after {
        content: "";
        position: absolute;
        height: 1px;
        width: 30%;
        background: #e5e7eb;
        top: 50%;
      }

      .divider::before {
        left: 0;
      }

      .divider::after {
        right: 0;
      }

      .style-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 12px;
      }

      .style-pill {
        padding: 12px;
        text-align: center;
        border-radius: 999px;
        background: #f3f4f6;
        cursor: pointer;
        font-weight: 500;
        transition: 0.2s ease;
        font-family: 'Poppins', sans-serif;
        font-size: 0.9rem;
        color: #303030;
        border: 1px solid transparent;
      }

      .style-pill:hover:not(.disabled) {
        background: #e0e7ff;
        transform: scale(1.03);
        border-color: #6366f1;
      }

      .style-pill.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background: #f3f4f6;
      }

      @media (max-width: 480px) {
        .style-grid {
          grid-template-columns: repeat(2, 1fr);
        }
        
        .custom-input-card {
          flex-direction: column;
        }
        
        .apply-btn {
          width: 100%;
        }
      }
    `}</style>

        </ModalBody>
      </Modal>

      {/* Word Limit Warning Dialog */}
      <Dialog
        open={wordLimitDialogOpen}
        onClose={handleWordLimitDialogClose}
        aria-labelledby="word-limit-dialog-title"
        aria-describedby="word-limit-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: 3,
            padding: 2,
            minWidth: 400,
          }
        }}
      >
        <DialogTitle
          id="word-limit-dialog-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#ef4444',
            fontWeight: 600
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          Word Limit Exceeded
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="word-limit-dialog-description"
            sx={{
              color: '#4b5563',
              fontSize: '1rem'
            }}
          >
            You have entered <strong>{inputWordCount}</strong> words, which exceeds the maximum limit of <strong>1500 words</strong>.
          </DialogContentText>
          <Box sx={{ mt: 2, p: 2, bgcolor: '#f3f4f6', borderRadius: 2 }}>
            <Typography variant="body2" sx={{ color: '#1f2937' }}>
              Please reduce your text to 1500 words or less to continue with paraphrasing.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleWordLimitDialogClose}
            variant="contained"
            sx={{
              bgcolor: '#ef4444',
              '&:hover': {
                bgcolor: '#dc2626'
              },
              borderRadius: 2,
              px: 4
            }}
          >
            OK, Got it
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
        }}
      >
        <Loader loading={loading} />
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            px: 2,
            py: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              mb: 1.5,
              flexShrink: 0,
            }}
          >
            {/* LEFT SIDE - Breadcrumb */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  bgcolor: "white",
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "divider",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                }}
              >
                <Breadcrumbs
                  separator={
                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />
                  }
                  aria-label="breadcrumb"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

                    <Link
                      to="/docTags"
                      onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                      style={{
                        textDecoration: "none",
                        color: "#667eea",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      MultiTool AI
                    </Link>

                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />

                    <Typography
                      sx={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(102, 126, 234, 0.08)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      AI Paraphraser
                    </Typography>
                  </Box>
                </Breadcrumbs>
              </Paper>
            </Box>

            {/* CENTER CONTENT */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <AutoFixHigh sx={{ fontSize: 36, color: "primary.main" }} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: 22,
                      fontWeight: 700,
                      color: "primary.main",
                    }}
                  >
                    AI Paraphraser
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary", fontStyle: "italic" }}
                  >
                    Transform your text with intelligent rephrasing powered by
                    AI
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Tone Selection Bar - Fixed height */}
          <Box sx={{ flexShrink: 0, mb: 1.5 }}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 3,
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <CardContent sx={{ pb: 2, "&:last-child": { pb: 2 } }}>
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    Output Format
                  </Typography>
                  <Typography
                    variant="caption"
                  >
                    Select how you want to display the paraphrased content
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1.5,
                    alignItems: "center",
                    minHeight: 40,
                  }}
                >
                  {buttons.map((button) => (
                    <Chip
                      key={button.id}
                      icon={
                        <span style={{ fontSize: "16px" }}>{button.icon}</span>
                      }
                      label={button.label}
                      disabled={!inputText || !accessToParaphrase}
                      onClick={() => handleToneClick(button.id)}
                      color={selectedTone === button.id ? "primary" : "default"}
                      variant={selectedTone === button.id ? "filled" : "outlined"}
                      sx={{
                        height: "36px",
                        fontSize: "0.85rem",
                        fontWeight: 600,
                        transition: "all 0.3s",
                        cursor: "pointer",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: 2,
                        },
                      }}
                    />
                  ))}

                  <Box
                    sx={{
                      ml: "auto",
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {renderSelect()}

                    <Button
                      variant="contained"
                      onClick={() => handleFutureButton("custom")}
                      disabled={!accessToParaphrase || !inputText.trim()}
                      startIcon={<Tune />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        height: 36,
                        minWidth: 100,
                        background: inputWordCount > 1500
                          ? "#ef4444"
                          : "linear-gradient(45deg, #667eea, #764ba2)",
                        '&:hover': {
                          background: inputWordCount > 1500
                            ? "#dc2626"
                            : "linear-gradient(45deg, #764ba2, #667eea)",
                        }
                      }}
                    >
                      {customText}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Main content area - takes remaining height */}
          <Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 3,
                height: "100%",
              }}
            >
              {/* Input Card */}
              <Card
                elevation={4}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, flexGrow: 1 }}
                  >
                    📝 Input Text
                  </Typography>
                  <Chip
                    label={`${inputWordCount} Words`}
                    size="small"
                    sx={{
                      bgcolor: inputWordCount > 1500 ? "#ef4444" : "rgba(255,255,255,0.2)",
                      color: "white",
                      fontWeight: 600,
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    p: 2,
                    overflow: "auto",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f5f5f5",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": {
                        background: "#a8a8a8",
                      },
                    },
                  }}
                >
                  <TextField
                    multiline
                    fullWidth
                    value={inputText}
                    onChange={handleInputChange}
                    placeholder="✨ Start typing or paste your text here to paraphrase..."
                    variant="outlined"
                    InputProps={{
                      sx: {
                        fontSize: "15px",
                        lineHeight: 1.6,
                        height: "100%",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      height: "100%",
                      "& .MuiInputBase-root": {
                        height: "100%",
                        alignItems: "flex-start",
                      },
                      "& textarea": {
                        height: "100% !important",
                        overflow: "auto !important",
                        resize: "none",
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    p: 2,
                    bgcolor: "black.50",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Circle
                      sx={{
                        fontSize: 10,
                        color: inputWordCount > 1500 ? "error.main" : "success.main",
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, color: "text.secondary" }}
                    >
                      {inputWordCount} / 1500 Words
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <Button
                      component="label"
                      variant="outlined"
                      size="small"
                      disabled={!accessToUpload}
                      startIcon={<CloudUpload />}
                      sx={{ borderRadius: 2, textTransform: "none" }}
                    >
                      Upload
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".txt"
                        hidden
                        onChange={handleFileUpload}
                      />
                    </Button>

                    <Button
                      variant="contained"
                      size="small"
                      onClick={onPetAssistant}
                      disabled={!inputText || !accessToParaphrase}
                      startIcon={<AutoFixHigh />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        background: inputWordCount > 1500
                          ? "#ef4444"
                          : "linear-gradient(45deg, #667eea, #764ba2)",
                        '&:hover': {
                          background: inputWordCount > 1500
                            ? "#dc2626"
                            : "linear-gradient(45deg, #764ba2, #667eea)",
                        }
                      }}
                    >
                      {!isParaphrase ? "Paraphrase" : "Re-Phrase"}
                    </Button>

                    <IconButton
                      size="small"
                      onClick={handleDelete1}
                      disabled={!accessToDelete}
                      sx={{
                        color: accessToDelete ? "error.main" : "black.500",
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Box>
                </Box>
              </Card>

              {/* Output Card */}
              <Card
                elevation={4}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  background: "linear-gradient(145deg, #ffffff 0%, #e8f5e9 100%)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "success.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    ✨ Paraphrased Result
                  </Typography>
                  <Chip
                    label={`${outputWordCount} Words`}
                    size="small"
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      color: "white",
                      fontWeight: 600,
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    p: 2,
                    overflow: "auto",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f5f5f5",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": {
                        background: "#a8a8a8",
                      },
                    },
                  }}
                >
                  <TextField
                    multiline
                    fullWidth
                    value={outputText}
                    placeholder="Your paraphrased text will appear here..."
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                      sx: {
                        fontSize: "15px",
                        lineHeight: 1.6,
                        height: "100%",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      height: "100%",
                      "& .MuiInputBase-root": {
                        height: "100%",
                        alignItems: "flex-start",
                      },
                      "& textarea": {
                        height: "100% !important",
                        overflow: "auto !important",
                        resize: "none",
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    p: 2,
                    bgcolor: "black.50",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Circle sx={{ fontSize: 10, color: "success.main" }} />
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, color: "text.secondary" }}
                    >
                      {outputWordCount} Words Generated
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <IconButton
                      size="small"
                      onClick={handleDownload}
                      disabled={!outputWordCount}
                      sx={{
                        color: outputWordCount ? "success.main" : "black.500",
                      }}
                    >
                      <Download />
                    </IconButton>

                    <IconButton
                      size="small"
                      onClick={handleCopy}
                      disabled={!outputWordCount}
                      sx={{
                        color: outputWordCount ? "info.main" : "black.500",
                      }}
                    >
                      <ContentCopy />
                    </IconButton>

                    <IconButton
                      size="small"
                      onClick={handleDelete}
                      disabled={!accessToDelete || !outputWordCount}
                      sx={{
                        color:
                          accessToDelete && outputWordCount
                            ? "error.main"
                            : "black.500",
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});

export default connect(mapStateToProps)(NewParaphrase);

